import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const argentineNames = ['María González', 'Laura Fernández', 'Sofía Rodríguez', 'Carolina Martínez', 'Valeria López', 'Gabriela Sánchez', 'Alejandra Pérez', 'Natalia Romero', 'Andrea Torres', 'Daniela Castro'];
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showNotification = () => {
      const randomName = argentineNames[Math.floor(Math.random() * argentineNames.length)];
      const randomCity = argentineCities[Math.floor(Math.random() * argentineCities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 3000);
    // Recurring notifications
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 7000 + 8000); // Random between 8-15 seconds
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-12">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: 50
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-6 right-6 z-50 bg-white rounded-lg shadow-2xl p-4 max-w-sm border-l-4 border-green-500" role="status" aria-live="polite" data-id="element-13">
          <div className="flex items-start gap-3" data-id="element-14">
            <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-15" />
            <div data-id="element-16">
              <p className="font-bold text-gray-900 text-sm" data-id="element-17">
                {currentName} de {currentCity}
              </p>
              <p className="text-gray-600 text-sm mt-1" data-id="element-18">
                acaba de comprar{' '}
                <span className="font-semibold" data-id="element-19">Cansancio Invisible</span>
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}